import React, { useState, useRef } from "react";
import ReactDOM from "react-dom";
import "./styles.css";
import close from "./iconoPopUpRegistro/close.svg";
import { registrarUsuario } from "../../../../Mutations/Usuarios/metodos/index";
import PopUpAlert from "../PopUpAlerta";

import {
    avisoSoftwone,
    terminosSoftwone
} from "../../../../public/Pdf/Softwone/exportPDF";
import LoaderLogoSoftwone from "_layout/assets/svg/Animaciones/logoSoftwone";
import Validaciones from "@renedelangel/helpers/lib/Validaciones";
import { rgxNombre } from "helpers/regexp";


const {trim} = Validaciones;


export default function PopUpRegistrarse(props) {
    let { loginInside, 
        registrarseState, 
        loginPrincipal,
        propsSetOpenAlert,
        propsSetAlert 
    } = props;
    loginInside(false);

    const cleanState = {
        usuario: "",
        nombre: "",
        apellidos: "",
        correo: "",
        lada: "",
        telefono: "",
        empresa: "",
        puesto: "",
        password: "",
        confirmarPassword: "",
        checkbox: false
    };

    const cleanErrorState = {
        usuario: { error: false, mensaje: "" },
        nombre: { error: false, mensaje: "" },
        apellidos: { error: false, mensaje: "" },
        correo: { error: false, mensaje: "" },
        lada: { error: false, mensaje: "" },
        telefono: { error: false, mensaje: "" },
        empresa: { error: false, mensaje: "" },
        puesto: { error: false, mensaje: "" },
        password: { error: false, mensaje: "" },
        confirmarPassword: { error: false, mensaje: "" },
        checkbox: { error: false, mensaje: "" }
    };

    const [datosRegistro, setDatosRegistro] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [openAlert, setOpenAlert] = useState(false);
    const [textoAlert, setTextoAlert] = useState({
        titulo: "",
        mensaje: ""
    });
    const [disabled, setDisabled] = useState(false);
    const [loading, setLoading] = useState(false);

    const usuarioRef = useRef(null);
    const nombreRef = useRef(null);
    const correoRef = useRef(null);
    const ladaRef = useRef(null);
    const telefonoRef = useRef(null);
    const empresaRef = useRef(null);
    const puestoRef = useRef(null);
    const passwordRef = useRef(null);
    const confirmarPasswordRef = useRef(null);

    const regexpCorreo = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
    const rgxPassword = /^(?=(.*[\d]){1,})(?=(.*[a-zñ]){1,})(?=(.*[A-ZÑ]){1,})(?=(.*[@#$%¡!*=<>()|¿?&-]){1,})(?:[\da-zA-ZÑñ=@#$%¡!*<>()|¿?&-]){8,30}$/;
    const rgxPhoneNumber = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

    function handleChange(e) {
        const { name, value } = e.target;
        setDatosRegistro(prevState => {
            return {
                ...prevState,
                [name]: value
            };
        });
    }

    function handleValidaciones({
        usuario,
        nombre,
        correo,
        telefono,
        password,
        confirmarPassword,
        checkbox
    }) {

        let error;
        let validaciones = [
            {
                condicion: !rgxNombre.test(nombre) || trim(nombre) === "",
                ref: nombreRef,
                keyError: "nombre",
                mensajeError: "Debe indicar un nombre válido nombre"
            },
            {
                condicion: !rgxNombre.test(usuario) || trim(usuario) === "",
                ref: usuarioRef,
                keyError: 'usuario',
                mensajeError: "Debe indicar un usuario válido"
            },
            {
                condicion: usuario.length < 8,
                ref: usuarioRef,
                keyError: 'usuario',
                mensajeError: "El usuario debe ser de por lo menos 8 caracteres"
            },
            {
                condicion: correo == null || correo == "",
                ref: correoRef,
                keyError: "correo",
                mensajeError: "Debe indicar un correo"
            },
            {
                condicion: !regexpCorreo.test(correo),
                ref: correoRef,
                keyError: "correo",
                mensajeError: "Debe indicar un correo valido"
            },
            {
                condicion: telefono == null || telefono == "",
                ref: telefonoRef,
                keyError: "telefono",
                mensajeError: "Debe indicar un telefono"
            },
            {
                condicion: !rgxPhoneNumber.test(telefono),
                ref: telefonoRef,
                keyError: "telefono",
                mensajeError: "Debe indicar un telefono valido"
            },
            {
                condicion: telefono == null || telefono == "",
                ref: telefonoRef,
                keyError: "telefono",
                mensajeError: "Debe indicar un telefono"
            },
            {
                condicion: !rgxPassword.test(password),
                ref: passwordRef,
                keyError: "password",
                mensajeError:
                    "La contraseña debe ser de por lo menos 8 caracteres, llevar un símbolo, una mayúscula y un número"
            },
            {
                condicion: password == null || password == "",
                ref: passwordRef,
                keyError: "password",
                mensajeError: "Debe ingresar una contraseña"
            },
            {
                condicion: password !== confirmarPassword,
                ref: passwordRef,
                keyError: "password",
                mensajeError: "Las contraseñas no coinciden"
            },
            {
                condicion: !checkbox,
                keyError: "checkbox",
                mensajeError: "Para crear una cuenta debe aceptar los términos y condiciones",
                type: 'checkbox'
            }
        ];

        validaciones.forEach(({ condicion, ref, mensajeError, keyError, type }) => {
            if (error) return;
            if (condicion) {
                /* alert(mensajeError); */

                setErrorState({...cleanErrorState,
                    [keyError]:{
                    error: true,
                    mensaje: mensajeError}
                });

                if(type !== 'checkbox'){
                ref.current.focus();
                ref.current.select();
                }
                error = true;
            }
        });

        if (error) return error;
    }


    const {
        usuario,
        nombre,
        correo,
        lada,
        telefono,
        empresa,
        puesto,
        password,
        confirmarPassword,
        checkbox
    } = datosRegistro;

    function ftRegistrar() {
        async function ftRegistrar() {
            setLoading(true);
            let {
                usuarioID,
                usuario,
                nombre,
                correo,
                lada,
                telefono,
                empresa,
                puesto,
                password,
                confirmarPassword
            } = datosRegistro;

            let error = handleValidaciones({
                usuario,
                nombre,
                correo,
                telefono,
                empresa,
                puesto,
                password,
                confirmarPassword,
                checkbox
            });

            if (error){
                setLoading(false);
                return error;}

            try {

                setDisabled(true);
                await registrarUsuario({
                    input: {
                        usuario,
                        nombre,
                        correo,
                        lada,
                        telefono,
                        empresa,
                        puesto,
                        password
                    }
                });
                setLoading(false);
                registrarseState(false);
                loginPrincipal(false);
                propsSetAlert({
                    titulo: "Registro exitoso",
                    mensaje:
                        "El usuario se ha registrado de forma exitosa. Verifique su correo para finalizar el proceso"
                });
                propsSetOpenAlert(true);
                setDisabled(false);
            } catch ({ message }) {
                setLoading(false);
                setTextoAlert({
                    titulo: "Error",
                    mensaje: message
                });
                setOpenAlert(true);
                setDisabled(false);
            }
        }
        ftRegistrar();
    }



    return ReactDOM.createPortal(
        <>
            <div
                className="contenedorGeneralPopUpRegistro"
                onClick={() => {
                    registrarseState(false);
                    loginPrincipal(false);
                }}
            >
                <div
                    className="contenedorInternoPopUpRegistro"
                    onClick={e => {
                        e.stopPropagation();
                    }}
                >
                    <div className="closeRegister">
                        <img
                            onClick={() => {
                                registrarseState(false);
                                loginPrincipal(false);
                            }}
                            src={close}
                        />{" "}
                    </div>
                    <div className="contenedorProgresoRegistro">
                        <div className="lineaProgreso">
                            <div className="circuloLineaProgreso">
                                <h1>1</h1>
                            </div>
                            <h2>Registrese</h2>
                        </div>

                        <div className="lineaProgreso">
                            <div className="circuloLineaProgreso">
                                <h1>2</h1>
                            </div>
                            <h2>
                                Verifique <br />
                                su correo
                            </h2>
                        </div>

                        <div className="lineaProgreso">
                            <div className="circuloLineaProgreso">
                                <h1>3</h1>
                            </div>
                            <h2>
                                Acceda a <br />
                                nuestros recursos
                            </h2>
                        </div>
                    </div>

                    <div className="contenedorFormularioRegistro">

                        

                        

                        <div className="primeraSeccionFormularioRegistro">
                            <label for="nombreRegistro">
                                <h6>Nombre Completo*</h6>
                            </label>

                            <input
                                ref={nombreRef}
                                disabled={disabled}
                                className="inputRegistroNombre"
                                placeholder="Nombre*"
                                type="input"
                                id="nombreRegistro"
                                name="nombre"
                                value={nombre}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />

                            <label for="nombreRegistro" style= {{display: errorState.nombre.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.nombre.mensaje}</h6>
                            </label>
                        </div>

                        <div className="primeraSeccionFormularioRegistro">
                            <label for="usuarioRegistro">
                                <h6>Usuario*</h6>
                            </label>

                            <input
                                ref={usuarioRef}
                                disabled={disabled}
                                className="inputRegistroNombre"
                                placeholder="Usuario*"
                                type="input"
                                id="usuarioRegistro"
                                name="usuario"
                                value={usuario}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />

                            <label for="usuarioRegistro" style= {{display: errorState.usuario.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.usuario.mensaje}</h6>
                            </label>
                        </div>

                        

                        <div className="primeraSeccionFormularioRegistro">
                        <label for="correoRegistro">
                                <h6>Correo*</h6>
                            </label>
                            <input
                                id='correoRegistro'
                                ref={correoRef}
                                className="inputRegistroNombre"
                                disabled={disabled}
                                placeholder="Correo*"
                                type="input"
                                name="correo"
                                value={correo}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                            <label for="correoRegistro"style= {{display: errorState.correo.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.correo.mensaje}</h6>
                            </label>
                        </div>

                        <div className="primeraSeccionFormularioRegistro">
                        <label for="telefonoRegistro">
                                <h6>Telefono*</h6>
                            </label>
                            <input
                                id='telefonoRegistro'
                                ref={telefonoRef}
                                className="inputRegistroNombre"
                                disabled={disabled}
                                placeholder="Telefono*"
                                type="input"
                                name="telefono"
                                value={telefono}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                            <label for="telefonoRegistro" style= {{display: errorState.telefono.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.telefono.mensaje}</h6>
                            </label>
                        </div>

                        {/* <div className='terceraSeccionFormularioRegistro'>
                        <input ref={empresaRef} className='inputRegistroGrande' 
                        disabled={openAlert? true : false}placeholder='Empresa'
                        type='input'
                        name='empresa' value={empresa} onChange={e =>{
                            handleChange(e)}}/>
                        <input ref={puestoRef} className='inputRegistroGrande' 
                        disabled={openAlert? true : false}
                        placeholder='Puesto'
                        type='input'
                        name='puesto' value={puesto} onChange={e =>{
                            handleChange(e)}}/>
                    </div> */}

                        <div className="primeraSeccionFormularioRegistro">
                        <label for="passwordRegistro">
                                <h6>Contraseña*</h6>
                            </label>

                            <input
                                id = 'passwordRegistro'
                                ref={passwordRef}
                                className="inputRegistroNombre"
                                disabled={disabled}
                                placeholder="Contraseña*"
                                type="password"
                                name="password"
                                value={password}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />

                            <label for="passwordRegistro" style= {{display: errorState.password.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.password.mensaje}</h6>
                            </label>
                        </div>

                        <div className="primeraSeccionFormularioRegistro">

                            <label for="confirmarPasswordRegistro">
                                <h6>Confirmar la contraseña*</h6>
                            </label>

                            <input
                            id = ''
                                ref={confirmarPasswordRef}
                                className="inputRegistroNombre"
                                placeholder="Confirmar Contraseña*"
                                disabled={disabled}
                                type="password"
                                name="confirmarPassword"
                                value={confirmarPassword}
                                onChange={e => {
                                    handleChange(e);
                                }}
                            />
                            <label for="confirmarPasswordRegistro" style= {{display: errorState.password.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.password.mensaje}</h6>
                            </label>

                        </div>
                    </div>

                    <div className='c_agrupador_terminos_registro'>
                    <div className="terminosCondicionesRegistrarse">
                        <input
                            disabled = {disabled}
                            id={"checkBoxRegistro"}
                            type="checkbox"
                            checked= {checkbox}
                            onClick={e => {
                                let { value, name } = e.target;
                                let aux = {
                                    target: {
                                        name: name,
                                        value:
                                            value == "true" ? true : false
                                    }
                                };

                                handleChange(aux);
                            }}
                            name="checkbox"
                            value = {!checkbox}
                        />
                        <label for={"checkBoxRegistro"}>
                           <h6> He leído y comprendido los &nbsp; <a href={terminosSoftwone} target="_blank">Términos y condiciones</a> &nbsp; de
                            Softwone.com</h6>
                        </label>
                    </div>
                    <label for="checkBoxRegistro" style= {{display: errorState.checkbox.error ?  'flex' : 'none'}}>
                                <h6 style={{color: '#e3bf0f'}}>{errorState.checkbox.mensaje}</h6>
                            </label>
                    </div>

                    <button
                        className="buttonRegistrarse"
                        onClick={() => {
                            ftRegistrar();
                        }}
                        disabled = {disabled}
                        style = {{display: disabled ? 'none' : 'flex' }}
                    >
                        <h6>REGISTRARSE</h6>
                    </button>
                </div>
            </div>

            {openAlert ? (
                <PopUpAlert
                    titulo={textoAlert.titulo}
                    mensaje={textoAlert.mensaje}
                    open={setOpenAlert}
                />
            ) : (
                <></>
            )}

            {
                loading?
                <LoaderLogoSoftwone/> :
                <></>
            }
        </>,
        document.getElementById("login")
    );
}
